import React from 'react';
import SectionTitle from './SectionTitle';
import SectionSubTitle from './SectionSubTitle';
import SectionSubContainer from './SectionSubContainer';

export default ({ shipment }) => (
  <>
    <SectionTitle bubble="checkmark">
      {!shipment ? 'Order' : shipment.shipment_direction === 'delivery' ? 'Order' : 'Return'} received
    </SectionTitle>
    <SectionSubContainer>
      <SectionSubTitle>{shipment?.received_at}</SectionSubTitle>
    </SectionSubContainer>
  </>
);
